// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__gJ6PN","title":"error_title__TL5pr","text":"error_text__XYJ_I"};